export const SAFE_SEPARATOR = 'ưƽǐ';
export const NO_VALUE = '-';

export const MAX_MONEY_VALUE = 100_000_000;
export const MIN_MONEY_VALUE = -100_000_000;
